module.exports = __webpack_public_path__ + "static/media/UN-12.be4cbfad.jpg";